import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import classes from "./Video.module.css";

import { addHistory } from "../store/actions/authActions";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu.svg";

import MenuFunc from "./Menu";
import HLS from "./HLS";
import Countdown from "react-countdown";
import Confetti from "react-confetti";

import { ReactComponent as Play } from "../assets/svg/play-button.svg";
import { ReactComponent as Pause } from "../assets/svg/pause.svg";
import { ReactComponent as Download } from "../assets/svg/download.svg";

import { Helmet } from "react-helmet";

import ReactGA from "react-ga";

class Workout extends Component {
  constructor() {
    super();

    this.state = {
      menuToggled: false,
      confetti: false,
      finished: false,
      progress: 0,
      warming: true,
      timer_time: Date.now() + 5000,
      playing: true,
    };

    this.isFrSubdomain = window.location.hostname.startsWith("fr.");
  }

  handleDownload = (exerciseName) => {
    const url = `https://cdn.fitzet.com/static%2F${exerciseName}.mp4?alt=media`;
    const link = document.createElement("a");
    link.href = url;
    link.download = `${exerciseName}.mp4`;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  componentDidMount() {
    /*
    try {
      this.props.nosleep.enable();
    } catch (e) {
      console.log("too bad coudltn start wake");
    }

    */
  }

  componentWillUnmount() {
    try {
      this.props.nosleep.disable();
    } catch (e) {
      console.log("too bad coudltn stop wake");
    }
  }

  /*shouldComponentUpdate(nextProps, nextState) {
    if (this.state.playing !== nextState.playing) {
      // return false;
    }
  }
  */

  setstopRef = (ref) => {
    this.stopRef = ref;
  };

  setplayRef = (ref) => {
    this.playRef = ref;
  };

  setRefVideo = (ref) => {
    this.videoRef = ref;
  };

  setRef = (countdown) => {
    if (countdown) {
      this.countdownref = countdown.getApi();
    }
  };

  calcolateCalories = (minutes, met) => {
    return ((minutes * (met * 3.5 * 80)) / 200).toFixed(2);
  };

  countdownRenderer = ({ hours, minutes, seconds, completed }) => {
    return (
      <font>
        {this.state.warming ? "Starting in " : null}
        <span
          style={
            this.state.warming ? { color: "#EE1D52" } : { color: "#69C9D0" }
          }
        >
          {seconds}
        </span>
      </font>
    );
  };

  makeInstructions = (arr) => {
    let ins = arr.split("-").slice(1);

    return ins.map(function (i) {
      return <li key={i}>{i}</li>;
    });
  };

  gonext = () => {
    const p = this.state.progress;
    if (p + 1 < this.props.location.state.exercises.length) {
      this.setState({
        warming: true,
        timer_time: Date.now() + 5000,
        progress: p + 1,
      });
    } else if (p + 1 === this.props.location.state.exercises.length) {
      this.countdownref.stop();
      if (this.props.auth.uid) {
        let calories = this.calcolateCalories(
          this.props.location.state.minutes,
          this.props.met
        );
        this.props.addHistory({
          calories,
          id: this.props.auth.uid,
          category: this.props.location.state.category,
        });
      }
      this.setState({ finished: true });
      ReactGA.event({
        category: "User",
        action: "Entraînement terminé",
      });
    }
  };

  goprev = () => {
    const p = this.state.progress;
    if (p - 1 >= 0) {
      this.setState({
        warming: true,
        timer_time: Date.now() + 5000,
        progress: p - 1,
      });
    }
  };

  gopause = () => {
    this.countdownref.pause();
    this.videoRef.pause();

    //console.log(this.stopRef.style);
    //this.setplayRef.style.display = "block";
    this.stopRef.style.display = "none";
    this.playRef.style.display = "block";

    //this.setState({ ...this.state, playing: false });
  };

  goplay = () => {
    this.countdownref.start();
    this.videoRef.play();
    this.stopRef.style.display = "block";
    this.playRef.style.display = "none";

    //this.setState({ ...this.state, playing: true });
  };

  countdownDone = () => {
    const minutes = this.props.location.state.minutes;
    const timer_exercise =
      minutes === 5 ? 30000 : minutes === "8" ? 45000 : 60000;

    const p = this.state.progress;
    if (this.state.warming) {
      this.setState({
        warming: false,
        timer_time: Date.now() + timer_exercise,
      });
    } else if (
      !this.state.warming &&
      p + 1 < this.props.location.state.exercises.length
    ) {
      this.setState({
        warming: true,
        timer_time: Date.now() + 5000,
        progress: p + 1,
      });
    } else {
      if (this.props.auth.uid) {
        let calories = this.calcolateCalories(
          this.props.location.state.minutes,
          this.props.met
        );
        this.props.addHistory({
          calories,
          id: this.props.auth.uid,
          category: this.props.location.state.category,
        });
      }
      this.setState({ finished: true });
      ReactGA.event({
        category: "User",
        action: "Entraînement terminé",
      });
    }
  };

  render() {
    if (
      !this.props.location.state ||
      this.props.location.state.exercises.length < 1 ||
      this.props.direct
    )
      return <Redirect to="/select-workout" />;

    try {
      this.props.nosleep.enable();
    } catch (e) {
      console.log("too bad coudltn start wake");
    }

    const exercises = this.props.location.state.exercises;
    const minutes = this.props.location.state.minutes;
    const category = this.props.location.state.category;
    // const soundEffect = this.props.location.state.audio;

    const { profile, audio } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }

    const Layout = () => {
      return (
        <div>
          <div className={classes.Video}>
            <div className={classes.videoContainer}>
              <HLS
                data={exercises[this.state.progress].name}
                warming={this.state.warming}
                setRefVideo={this.setRefVideo}
                soundEffect={audio}
              />
            </div>
          </div>

          <div style={{ padding: "0px 20px 20px 20px" }}>
            <div style={{ height: "50px" }} className="counterStuff">
              <h2
                style={{
                  float: "left",
                  fontSize: "18px",
                  padding: "5px 0px",
                }}
              >
                <Countdown
                  ref={this.setRef}
                  renderer={this.countdownRenderer}
                  date={this.state.timer_time}
                  onComplete={this.countdownDone}
                />{" "}
                seconds {!this.state.warming ? " left" : null}
              </h2>
              <h2
                style={{
                  float: "right",
                  fontSize: "15px",
                  backgroundColor: "#EE1D52",
                  padding: "6px",
                  borderRadius: "2px",
                }}
              >
                {this.state.progress + 1 + "/10"} {category.toUpperCase()}
              </h2>
            </div>

            <h2
              style={{
                textTransform: "capitalize",
              }}
              className="putUp"
            >
              {exercises[this.state.progress].formatted}
            </h2>

            <ul
              style={{
                fontSize: "18px",
                textAlign: "left",
                padding: "0px 20px",
              }}
            >
              {this.makeInstructions(
                exercises[this.state.progress].instructions
              )}
            </ul>

            <p style={{ fontSize: "18px", display: "flex" }}>
              <button
                style={{
                  fontSize: "18px",
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                  margin: "10px 10px 10px 0px",
                }}
                onClick={() => {
                  this.goprev();
                }}
              >
                PREV
              </button>

              <button
                ref={this.setstopRef}
                style={{
                  fontSize: "18px",
                  background: "#EE1D52",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                  margin: "10px",
                }}
                onClick={() => {
                  this.gopause();
                }}
              >
                <Pause
                  style={{ paddingTop: "4px" }}
                  height={20}
                  width={20}
                  fill={"#fff"}
                />
              </button>

              <button
                ref={this.setplayRef}
                style={{
                  fontSize: "18px",
                  background: "#EE1D52",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                  margin: "10px",
                  display: "none",
                }}
                onClick={() => {
                  this.goplay();
                }}
              >
                <Play
                  style={{ paddingTop: "4px" }}
                  height={20}
                  width={20}
                  fill={"#fff"}
                />
              </button>

              <button
                style={{
                  fontSize: "18px",
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                  margin: "10px 0px 10px 10px",
                }}
                onClick={() => {
                  //this.setState({ finished: true });
                  this.gonext();
                }}
              >
                NEXT
              </button>

              {this.isFrSubdomain && (
                <button
                  style={{
                    fontSize: "18px",
                    background: "#ff9800",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                    margin: "10px 0px 10px 10px",
                  }}
                  onClick={() => {
                    this.handleDownload(exercises[this.state.progress].name);
                  }}
                  title="Télécharger cette vidéo"
                >
                  <Download
                    style={{ paddingTop: "4px" }}
                    height={20}
                    width={20}
                    stroke={"#fff"}
                  />
                </button>
              )}
            </p>
          </div>
        </div>
      );
    };

    if (this.state.finished) {
      this.props.audio.src = `https://cdn.fitzet.com/static%2Fsoundchimeapplause.mp3?alt=media`;
      this.props.audio.play();
    }
    return (
      <div>
        <Helmet>
          <title>Session Entraînement</title>
          <meta
            name="description"
            content="Boxfit est l'application web ultime pour les entraînements à la maison avec plus de 390 vidéos, 10 catégories différentes d'exercice et fonctionnalités premium, et l'historique de vos entraînements & Radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/account" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="Boxfit est l'application web ultime pour les entraînements à la maison avec plus de 390 vidéos, 10 catégories différentes d'exercice et fonctionnalités premium, et l'historique de vos entraînements & Radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }} className="menuStuff">
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          {this.state.finished && (
            <div>
              <div style={{ overflow: "hidden" }}>
                <Confetti
                  opacity={0.6}
                  style={{ margin: "auto" }}
                  height="800"
                  width="350"
                  initialVelocityY={20}
                  initialVelocityX={10}
                />
              </div>
              <div style={{ height: "80px" }}></div>
              <div style={{ padding: "0px 20px 20px 20px" }}>
                <h2
                  style={{
                    fontSize: "28px",
                    color: "#69C9D0",
                    borderRadius: "2px",
                  }}
                >
                  Workout Completed!
                </h2>
                <div style={{ height: "5px" }}></div>

                <h2
                  style={{
                    fontSize: "22px",
                    borderRadius: "2px",
                  }}
                >
                  Time → 00:{minutes > 9 ? minutes : "0" + minutes}:00{" "}
                  <span role="img" aria-label="time">
                    🕗
                  </span>
                </h2>

                <h2
                  style={{
                    fontSize: "22px",
                    borderRadius: "2px",
                  }}
                >
                  Calories Burned →{" "}
                  {this.calcolateCalories(minutes, this.props.met)}
                  <span role="img" aria-label="calories">
                    🔥
                  </span>
                </h2>
                <div style={{ height: "30px" }}></div>

                {!profile.isPremium ? (
                  <button
                    style={{
                      fontSize: "18px",
                      borderColor: "#69C9D0",
                      backgroundColor: "#000",
                      padding: "10px",
                      border: "1px solid",
                      borderRadius: "4px",
                      fontWeight: "600",
                      width: "100%",
                      color: "white",
                    }}
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/upgrade",
                      });
                    }}
                  >
                    <span role="img" aria-label="like">
                      👉
                    </span>{" "}
                    {profile.startedtrial
                      ? "Essai Premium"
                      : "Essayez la version Premium gratuitement"}
                  </button>
                ) : null}

                {!profile.isPremium ? (
                  <div style={{ height: "30px" }}></div>
                ) : null}

                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/select-workout",
                    });
                  }}
                >
                  HOME
                </button>
              </div>

              {/*<audio autoPlay playsInline>
                <source
                  src={`https://cdn.fitzet.com/static%2Fsoundchimeapplause.mp3?alt=media`}
                  type="audio/mpeg"
                />
              </audio>*/}
            </div>
          )}
          {!this.state.finished && <Layout />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let exercises = state.firestore.ordered["categories"];
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
    state.firebase.profile.isPremium = true;
  }
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    met: exercises ? exercises[0]["met"] : null,
    audio: state.auth.audio,
    nosleep: state.auth.nosleep,
    direct: state.auth.direct,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addHistory: (obj) => dispatch(addHistory(obj)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "categories",
      where: [["name", "==", props.location.state.category || ""]],
    },
  ])
)(Workout);

//export default connect(mapStateToProps, mapDispatchToProps)(Workout);
